import styled from 'styled-components';
import GlobalButton from '../../common/components/GlobalButton';
import { maxMobile, SecondaryColor, wMBold, primaryFont, secondaryFont, wMedium, primaryHeadingColor, wLight, maxTablet, minExtraLargeScreen } from '../../../Utils/utilsStyle';
// import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { PERSONALITY_INSIGHTS_ROUTE } from 'Utils/Constants';
// import { actions as certificationActions } from '../../../Slice/CertificationSlice';
// import { actions as uiActions } from '../../../Slice/UISlice';
import { Popover, Spin } from 'antd';
import { useState, useEffect } from 'react';
import { actions as personActions } from '../../../Slice/PersonProfileSlice';
import {
  selectSalesAlignmentInsightCell,
  selectSalesAlignmentInsightsLoading,
} from '../../../Selector/PersonProfileSelector';
import ListItem from '../../common/components/ListItem';
import { CheckCircleFilled, LoadingOutlined } from '@ant-design/icons';
import { scrollbar } from '../../../Utils/utilsStyle';

const Wrapper = styled.div`
  .inner-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background: #FFF;
    width: 100%;
    row-gap: 16px;
    .level-div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      row-gap: 5px;
      .level-text {
        background: linear-gradient(130deg, #E13C39 15.46%, #EFB041 40.21%, #72C140 64.91%, #448EF7 89.78%);
        background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-family: ${secondaryFont};
        font-size: 16px;
        font-weight: ${wMBold};
        line-height: 19px;
        letter-spacing: -0.264px;
        min-height: 20px;

      }
      .sales-header {
        color: #424B50;
        font-family: ${secondaryFont};
        font-size: 12px;
        font-weight: ${wMBold};
        line-height: 19px;
        letter-spacing: -0.264px;
      }
    }
    .btn-div {
      cursor: pointer;
      button {
        width: 107px;
        height: 32px;
        font-family: ${primaryFont};
        font-size: 14px;
        font-weight: ${wMedium};
        line-height: normal;
        letter-spacing: -0.414px;
      }
    }
  }
`;

const Heading = styled.h2`
  color: ${primaryHeadingColor};
  font-family: ${secondaryFont};
  font-size: 22px;
  font-weight: ${wMBold};
  letter-spacing: -0.66px;
  margin-bottom: 16px;
  margin-top: 14px;
  @media all and (max-width: ${minExtraLargeScreen}) {
    font-size: 20px;
  }
  @media all and (max-width: ${maxTablet}) {
    font-size: 18px;
  }
  @media all and (max-width: ${maxMobile}) {
    font-size: 16px;
    margin-bottom: 12px;
    margin-top: 12px;
  }
`;

const TooltipWrapper = styled.div`
  width: 363px;
  background-color: #fff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.16);
  border-radius: 12px;
  padding: 10px 5px 10px 0;
  @media all and (max-width: ${maxMobile}) {
    width: 300px;
  }
`;

const TooltipScrollable = styled.div`
  max-height: 489px;
  overflow-y: auto;
  padding: 0 24px 24px 24px;
  ${scrollbar}
  &::-webkit-scrollbar-track {
    background: transparent
  }
  &::-webkit-scrollbar {
    width: 5px;
    border-radius:8px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${SecondaryColor};
    border-radius: 12px;
  }
  @media all and (max-width: ${maxMobile}) {
    max-height: 350px;
  }
  
  .veritcal-tips {
    font-family: ${primaryFont};
    font-style: normal;
    font-weight: ${wLight};
    letter-spacing: -0.375px;
    font-size: 16px;
    line-height: 18px;

    @media all and (max-width: ${minExtraLargeScreen}) {
      font-size: 15px;
    }

    @media all and (max-width: ${maxTablet}) {
      font-size: 13px;
    }
  }

`;

type Props = {
  match: string;
  comparedPersonId: number;
  personType: string;
  disableBtn: boolean;
  approachTips?: string[];
  basePersonId?: number;
  personName?: string;
  personaColor?: string;
  rowId?: number;
};

const defaultProps = {
  match: '',
  comparedPersonId: 0,
  personType: '',
  disableBtn: false,
  approachTips: [],
  basePersonId: 0,
  personName: '',
  personaColor: '#000000ff',
  rowId: undefined,
}
const SalesAlignmentComponent = function SalesAlignmentComponent(props: Props) {
  const {
    match,
    comparedPersonId,
    personType,
    disableBtn,
    approachTips,
    basePersonId,
    personName,
    personaColor,
    rowId,
  } = props;
  // const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const anyInsightLoading = useSelector(selectSalesAlignmentInsightsLoading);

  const cachedCell = useSelector(
    (rowId !== undefined && rowId >= 0 && comparedPersonId > 0)
      ? selectSalesAlignmentInsightCell(rowId, comparedPersonId)
      : () => undefined,
  );

  const effectiveCommonalitiesData = cachedCell?.commonalitiesData ?? [];

  const effectiveCommonalitiesTitle = cachedCell?.commonalitiesTitle ?? '';

  const effectiveApproachTips = cachedCell?.approachTips ?? approachTips;

  // const viewInsightsHandler = (personId: number, personType: string) => {
  //   dispatch(certificationActions.setScrollToId('tabs-details'));
  //   dispatch(uiActions.multipleSalesAlignment(false));
  //   navigate(`${PERSONALITY_INSIGHTS_ROUTE}${personId}&personType=${personType}&viewInsights=true`);
  // }

  const viewInsightsHandler = () => {
    if (anyInsightLoading) return;
    if (basePersonId && comparedPersonId) {
      if (rowId !== undefined) {
        if (
          cachedCell
          && cachedCell.loaded
          && cachedCell.basePersonId === basePersonId
          && cachedCell.personId === comparedPersonId
        ) {
          setIsTooltipVisible(true);
          return;
        }

        setIsLoading(true);
        dispatch(personActions.getSalesAlignmentInsight({
          rowId,
          fromPersonId: basePersonId,
          toPersonId: comparedPersonId,
          approachTips: effectiveApproachTips,
        }));
        return;
      }
    }
  }

  useEffect(() => {
    if (!isLoading) return;

    if (rowId !== undefined) {
      const done = cachedCell && !cachedCell.loading;
      if (done) {
        setIsLoading(false);
        setIsTooltipVisible(true);
      }
      return;
    }

    if (cachedCell && !cachedCell.loading) {
      setIsLoading(false);
      setIsTooltipVisible(true);
    }
  }, [isLoading, rowId, cachedCell]);

  const tooltipContent = (
    <TooltipWrapper>
      <TooltipScrollable>
        {effectiveApproachTips && effectiveApproachTips.length > 0 && (
          <div className="">
            <Heading>How to approach {personName?.split(' ')[0]}</Heading>
            <div className="d-flex flex-column">
              {(effectiveApproachTips as string[]).map((tip: string, index: number) => (
                <ListItem
                  key={index}
                  title={tip}
                  className='veritcal-tips'
                  icon={<CheckCircleFilled style={{ color: personaColor }} />}
                  noTruncate
                />
              ))}
            </div>
          </div>
        )}

        {effectiveCommonalitiesData && effectiveCommonalitiesData.length > 0 && (
          <div className="">
            <Heading>{effectiveCommonalitiesTitle || 'Commonalities'}</Heading>
            <div className="d-flex flex-column">
              {(effectiveCommonalitiesData as string[]).map((item: string, index: number) => (
                <ListItem
                  key={index}
                  title={item}
                  className='veritcal-tips'
                  icon={<CheckCircleFilled style={{ color: personaColor }} />}
                  noTruncate
                />
              ))}
            </div>
          </div>
        )}
      </TooltipScrollable>
    </TooltipWrapper>
  );

  return (
    <Wrapper className='sales-alignment-box'>
      <div className='inner-section'>
        <div className='level-div'>
          <div className='level-text'>
            {match}
          </div>
          <div className='sales-header'>
            Sales Alignment
          </div>
        </div>
        <div className='btn-div'>
          <Popover
            arrow={false}
            placement="bottom"
            content={tooltipContent}
            trigger="click"
            open={isTooltipVisible}
            zIndex={1}
            onOpenChange={(visible) => !visible && setIsTooltipVisible(false)}
            overlayInnerStyle={{ boxShadow: 'none', padding: 0, marginTop: '-35%' }}
          >
            <GlobalButton
              title={isLoading ? '' : 'View Insights'}
              IconLeft={isLoading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: '#fff' }} spin />} /> : undefined}
              buttonClassName="justify-content-center"
              textColor="#fff"
              outlineColor={SecondaryColor}
              bgColor={SecondaryColor}
              borderRadius='8px'
              innerSpace='8px 14px'
              disabled={disableBtn || isLoading || anyInsightLoading}
              onButtonClick={viewInsightsHandler}
            />
          </Popover>
        </div>
      </div>
    </Wrapper>
  )
}

SalesAlignmentComponent.defaultProps = defaultProps;
export default SalesAlignmentComponent;
